import { Box, CircularProgress } from '@mui/material';

const Spinner = ({ height = 100 }) => <Box
    sx={{
        width: '100%', display: 'flex', height: height, alignItems: 'center', justifyContent: 'center'
    }}>
    <CircularProgress color="primary" />
</Box>

export default Spinner